/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cm: NonNullable<unknown> }} Search_Value_HeightInputs */

const en_us2_search_value_height = /** @type {(inputs: Search_Value_HeightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const pt_br2_search_value_height = /** @type {(inputs: Search_Value_HeightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const es_419_search_value_height = /** @type {(inputs: Search_Value_HeightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const pt_pt2_search_value_height = /** @type {(inputs: Search_Value_HeightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const fr_fr2_search_value_height = /** @type {(inputs: Search_Value_HeightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const de_de2_search_value_height = /** @type {(inputs: Search_Value_HeightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

const it_it2_search_value_height = /** @type {(inputs: Search_Value_HeightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.cm} cm`)
};

/**
* | output |
* | --- |
* | "{cm} cm" |
*
* @param {Search_Value_HeightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_value_height = /** @type {((inputs: Search_Value_HeightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Value_HeightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_value_height(inputs)
	if (locale === "es-419") return es_419_search_value_height(inputs)
	if (locale === "pt-PT") return pt_pt2_search_value_height(inputs)
	if (locale === "fr-FR") return fr_fr2_search_value_height(inputs)
	if (locale === "de-DE") return de_de2_search_value_height(inputs)
	if (locale === "it-IT") return it_it2_search_value_height(inputs)
	return en_us2_search_value_height(inputs)
});
export { search_value_height as "search.value_height" }